var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox integral-order-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "filter-bar" },
            [
              _c("el-input", {
                staticClass: "keyword-input",
                attrs: {
                  placeholder: "请输入订单号/产品名称/手机号",
                  size: "small",
                  clearable: "",
                  "prefix-icon": "el-icon-search",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearch($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "keyword", $$v)
                  },
                  expression: "query.keyword",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("订单状态："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-140",
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "全部",
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.orderStatusOptions, function (item) {
                      return _c("el-option", {
                        key: "st-" + String(item.value),
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "filter-label" }, [
                    _vm._v("订单类型："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-140",
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "全部",
                      },
                      model: {
                        value: _vm.query.orderType,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "orderType", $$v)
                        },
                        expression: "query.orderType",
                      },
                    },
                    _vm._l(_vm.orderTypeOptions, function (item) {
                      return _c("el-option", {
                        key: "ot-" + String(item.value),
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset-btn",
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "data-table integral-order-table",
              attrs: {
                data: _vm.tableData,
                size: "small",
                "header-cell-style": _vm.tableHeaderCellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单号",
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "产品名称",
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单金额", "min-width": "100", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoneyYuan(
                                scope.row.totalPrice + scope.row.freight
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "平台收款", "min-width": "130", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "platform-cell" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.formatMoneyYuan(scope.row.platformIncome)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "platform-sub" }, [
                            _vm._v(
                              "福豆：" +
                                _vm._s(
                                  _vm.formatMoneyYuan(scope.row.fuDouPayPrice)
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "platform-sub" }, [
                            _vm._v(
                              "微信：" +
                                _vm._s(
                                  _vm.formatMoneyYuan(scope.row.wechatPayPrice)
                                )
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品售价", "min-width": "100", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatMoneyYuan(scope.row.goodsPrice)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integralUsed",
                  label: "积分消耗",
                  "min-width": "90",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integralPriceUsed",
                  label: "积分抵扣金额",
                  "min-width": "90",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatMoneyYuan(scope.row.integralPriceUsed)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "运费", "min-width": "80", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatMoneyYuan(scope.row.freight)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusDesc",
                  label: "订单状态",
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderTypeDesc",
                  label: "订单类型",
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "售后状态", "min-width": "120", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.aftersaleId
                          ? _c("div", { staticClass: "aftersale-plain" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.aftersaleStatusDesc || "无售后"
                                )
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "aftersale-wrap" },
                              [
                                _c("div", { staticClass: "aftersale-plain" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.aftersaleStatusDesc || "有售后"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["admin:shopintegral:aftersale"],
                                        expression:
                                          "['admin:shopintegral:aftersale']",
                                      },
                                    ],
                                    staticClass: "aftersale-link",
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goAftersaleList(
                                          scope.row.orderNo
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              查看 >\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "72",
                  fixed: "right",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:shopintegral:order:info"],
                                expression: "['admin:shopintegral:order:info']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageData.page,
                  "page-sizes": _vm.constants.page.limit,
                  "page-size": _vm.pageData.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("integral-order-detail", {
        attrs: { visible: _vm.detailVisible, "order-no": _vm.detailOrderNo },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }